import { render, staticRenderFns } from "./JobBoardDetail.vue?vue&type=template&id=46560b2c"
import script from "./JobBoardDetail.vue?vue&type=script&lang=js"
export * from "./JobBoardDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports